//中级会计职称init 初级mid
const majorTag = 'mid'
const settings = {
  //项目名称
  title: '中级会计职称无纸化考试模拟系统',
  //机考辅导类型
  category: '中级会计职称',
  //机考辅导ID
  majorID:2,//中级会计职称
  //辅导名称
  majorTag:majorTag,
  //生产环境二级路径
  publicPath: '/qzSim/'+majorTag+'/',
  //生产环境构建文件目录
  outputDir: 'webApp',
  //静态资源放置目录
  assetsDir: 'static',
  //aes密钥
  aesKey: '823s4125660ijf;*',
  //iv密钥
  ivKey: 'qyu148#4(1p_1^4;',
  //请求接口地址  (默认：'/simPaperGw/moniexam'； 需要qzCloud在接口加上'/qzCloud')
  baseApi: ['/simPaperGw/moniexam', '/qzCloud'],
  //请求重试delay
  retryDelay: 5000
}

module.exports = settings
